<template>
  <div class="page-footer">
    <div class="footer-logo">
      <img src="https://cdn.magicmart.vip/website/assets/footerLogo.png" alt="logo">
    </div>
    <div class="footer-info">
      <div class="footer-icon">
        <div class="icon-wrapper" @mouseenter="showWxQr = true" @mouseleave="showWxQr = false">
          <img src="https://cdn.magicmart.vip/website/assets/wxIcon.png" alt="微信">
          <div class="qr-popup qr-popup-wx" v-if="showWxQr">
            <img src="https://cdn.magicmart.vip/website/assets/wxQr.png" alt="微信二维码" class="qr-image">
          </div>
        </div>
        <div class="icon-wrapper" @mouseenter="showHongshuQr = true" @mouseleave="showHongshuQr = false">
          <img src="https://cdn.magicmart.vip/website/assets/hongshuIcon.png" alt="小红书">
          <div class="qr-popup qr-popup-hongshu" v-if="showHongshuQr">
            <img src="https://cdn.magicmart.vip/website/assets/hongshuQr.png" alt="小红书二维码" class="qr-image">
          </div>
        </div>
      </div>
      <div class="footer-link">
        <div class="link-wrapper" @mouseenter="showBossQr = true" @mouseleave="showBossQr = false">
          <a href="#">加入我们</a>
          <div class="qr-popup qr-popup-boss" v-if="showBossQr">
            <img src="https://cdn.magicmart.vip/website/assets/bossQr.png" alt="boss二维码" class="qr-image">
          </div>
        </div>
        <div class="line"></div>
        <div class="link-wrapper" @mouseenter="showContactWxQr = true" @mouseleave="showContactWxQr = false">
          <a href="#">联系我们</a>
          <div class="qr-popup qr-popup-contact" v-if="showContactWxQr">
            <img src="https://cdn.magicmart.vip/website/assets/wxQr.png" alt="微信二维码" class="qr-image">
          </div>
        </div>
        <div class="line"></div>
        <a href="#" @click.prevent="navigateToIntellectual">知识产权保护</a>
        <div class="line"></div>
        <a href="https://cdn.magicmart.vip/resource/magic/user.html">隐私声明</a>
      </div>
      <div class="footer-text">
        杭州魔力玛特科技有限公司地址:浙江省杭州市余杭区仓前街道良睦路1399号12幢3楼
      </div>
      <div class="footer-copyright">
        <p>COPYRIGHT</p>
        <div class="line"></div>
        <!-- <p>浙公网安备127318723131号</p>
        <div class="line"></div> -->
        <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022024345号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  data() {
    return {
      showWxQr: false,
      showHongshuQr: false,
      showBossQr: false,
      showContactWxQr: false
    }
  },
  methods: {
    navigateToIntellectual() {
      this.$router.push('/intellectual')
    }
  }
}
</script>

<style scoped>
.page-footer {
  height: 280px;
  background: #383838;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-logo {
  width: 193px;
  height: 41px;
}

.footer-logo img {
  width: 100%;
  height: 100%;
}

.footer-info {
  display: flex;
  flex-direction: column;
  margin-left: 112px;
}

.footer-icon {
  display: flex;
}

.icon-wrapper {
  position: relative;
  margin-right: 15px;
}

.footer-icon img {
  width: 27px;
  height: 27px;
  cursor: pointer;
}

.qr-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 10px;
  z-index: 1000;
}



.qr-image {
  width: 143px !important;
  height: 183px !important;
  display: block;
  margin-bottom: 8px;
}

.qr-popup p {
  margin: 0;
  font-size: 14px;
  color: #333;
  text-align: center;
}

.footer-link {
  display: flex;
  list-style: none;
  align-items: center;
  margin-top: 18px;
}

.link-wrapper {
  position: relative;
  display: flex;
}

.footer-link a {
  text-decoration: none;
  transition: opacity 0.3s;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 22px;
}

.footer-link a:hover {
  color: #A34EFF
}

.line {
  width: 1px;
  height: 15px;
  background: #FFFFFF;
  margin-left: 30px;
  margin-right: 30px;
}

.footer-text {
  font-size: 16px;
  color: #A6A6A6;
  line-height: 22px;
  margin-top: 18px;
}

.footer-copyright {
  font-size: 16px;
  color: #A6A6A6;
  line-height: 22px;
  margin-top: 7px;
  display: flex;
  align-items: center;
}

.footer-copyright a {
  text-decoration: none;
  color: #A6A6A6;
  transition: color 0.3s;
}

.footer-copyright a:hover {
  color: #A34EFF;
}
</style>
